import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper1 = new Swiper(".section1 .mySwiper", {
  loop: true,
  speed: 600,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: { // 自动切换
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
    pauseOnMouseEnter: true,
  },
  pagination: {// 分页
    el: ".section1 .swiper-pagination",
    clickable: true,
  },
})

var swiper2 = new Swiper(".guide .mySwiper", {
  loop: true,
  speed: 800,
  spaceBetween: 10,
  autoplay: { // 自动切换
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
    pauseOnMouseEnter: true,
  },
  pagination: {// 分页
    el: ".guide .swiper-pagination",
    clickable: true,
  },
})